/* eslint-disable no-shadow */
/* eslint-disable no-use-before-define */
/* global Swiper */

import router from '../router';
import helpers from '../helpers';
// import analytics from '../analytics';

let slider;

const isMobile = helpers.isMobile();

const playChangePodcast = (title) => {

	const $slide = $(`[data-podcasts__name="${title}"]`);
	$slide.click();
};

const cliclEvent = () => {
	const $slide = $('.announcements__item[data-name="Подкаст"]');

	$slide.on('click', (event) => {
		const $target = $(event.currentTarget);
		const $title = $target.find('.announcements__subtitle').text();

		router.navigate('/podcasts').then(() => {
			playChangePodcast($title);
		});
	});
};

function init(link, pageName) {
	const parent = $(`[data-page="${pageName}-${link}"]`);
	const slide = $(parent).find(`.announcements__item[href="/${link}"]`);
	const slidePodcast = $(parent).find(`.announcements__item[data-article="/${link}"]`);

	$(slidePodcast).detach();
	$(slide).detach();

	slider = new Swiper('.announcements__slider .js-slider', {
		slidesPerView: 'auto',
		observer: true,
	});
}

function destroy() {
	slider.destroy();
}
export default {
	cliclEvent,
	init,
	destroy,
};
